import React from 'react';
import styled from 'styled-components';
import { Divider } from 'styled_components/Common/Divider';
import { useNavigate } from 'react-router-dom';

const Style = styled.div`
	width: 100%;
	height: 212px;
	padding-left: 10px;
	padding-right: 10px;

	display: flex;
	flex-direction: column;
	//align-items: center;
	justify-content: center;
	flex: 1;

	.section {
		position: relative;
		display: flex;
		cursor: pointer;
		align-items: center;
		//justify-content: space-between;
		//border: 1px solid green;
		height: 50px;

		.icon {
			display: flex;
			align-items: center;
			justify-content: center;
			.danger {
				width: 4px;
				height: 15px;
				border: 1px solid red;
				background-color: red;
				margin: 5px 2px 5px 0;
			}
			.medium {
				margin: 5px 2px;
				width: 4px;
				height: 25px;
				border: 1px solid #fd0;
				background-color: #fd0;
			}
			.good {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 80px;
				height: 35px;
				margin: 0 0 0 2px;
				padding: 18px 13px 18px 14px;
				border: 2px solid #00ad5c;
			}
		}
		.label {
			flex: 1;
		}
	}

	background: ${props => props.theme.white};
	color: ${props => props.theme.defaultFontColor};

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		width: 100%;
		height: 100%;
		padding-left: 10px;
		padding-right: 10px;

		.section {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-between;
			//border: 1px solid green;
			height: 75px;

			.icon {
				display: flex;
				align-items: center;
				justify-content: center;
				.danger {
					width: 5px;
					height: 30px;
					border: 1px solid red;
					background-color: red;
					margin: 5px 2px 5px 0;
				}
				.medium {
					margin: 5px 2px;
					width: 5px;
					height: 40px;
					border: 1px solid #fd0;
					background-color: #fd0;
				}
				.good {
					width: 80px;
					height: 50px;
					margin: 0 0 0 2px;
					padding: 18px 13px 18px 14px;
					border: 2px solid #b5d334;
				}
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		padding-left: 20px;
		padding-right: 20px;

		.section {
			height: 100px;
		}
	}
`;

export const CardList = ({ cypressId, id }) => {
	const navigate = useNavigate();

	return (
		<Style id={id} data-cy={cypressId} className='card-container'>
			<div className='section body10'>
				<div className='label'>Security</div>
				<div className='icon'>
					<div className='danger'></div>
					<div className='medium'></div>
					<div className='good labels21'>Secured</div>
				</div>
			</div>
			<div className='section body10' onClick={() => navigate('/portal/colocation/power')}>
				<div className='label'>Rack Count </div>
				<div className='contents'>104 </div>
				<Divider />
			</div>
			<div className='section body10' onClick={() => navigate('/portal/colocation/environment')}>
				<div className='label'>Weather Alerts</div>
				<div className='content'>( 1 )</div>
				<Divider />
			</div>
		</Style>
	);
};
